// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        featuredFeed: action.featuredFeed
      };
    },
    FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.featuredFeed
      };
    },
    FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.featuredFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
